<template>
    <div class="text-center">
      <v-bottom-sheet
        v-model="showModal"
        persistent
      >
        <v-sheet
          class="text-center"
          height="200px"
          color="primary"
        >
          <v-btn
            class="mt-6"
            text
            style="background-color: black;"
            color="#ffffff"
            @click="acceptPolitics"
          >
            Entendi e aceito
          </v-btn>
          <div class="py-3">
            Estamos usando cookies para lhe oferecer uma experiência melhor em nosso site. Para saber mais sobre cookies acesse nossa <a @click="toPoliticsPage" style="color: white;"> Política de Privacidade. </a>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
</template>

<script>
export default {
  data: () => ({
    showModal: !localStorage.getItem('aceptTerms')
  }),
  methods: {
    toPoliticsPage () {
      let routeData = this.$router.resolve({path: 'politicas-de-privacidade'})
      return window.open(routeData.href, '_blank')
    },

    acceptPolitics () {
      localStorage.setItem('aceptTerms', true)
      localStorage.setItem('dateAceptTerms', new Date())
      this.showModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/politics/ModalPrivacy.vue